import React from 'react';
import {
  Tabs as MaterialTabs,
  Tab as MaterialTab,
  withStyles,
  makeStyles,
  createStyles,
  Theme,
} from '@material-ui/core';
import { colors, dimensions } from '../../../theme';

type StyleProps = {
  paddingValue: number;
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    selectedTab: {
      color: `${colors.abbey} !important`,
      fontWeight: 800,
    },
    paddedTabContainer: ({ paddingValue }: StyleProps) => ({
      [theme.breakpoints.up('lg')]: {
        paddingLeft: paddingValue,
        paddingRight: paddingValue,
      },
    }),
  }),
);

const CustomTabs = withStyles({
  root: {
    border: '1px solid #E8E9EC',
    height: 56,
  },
  indicator: {
    backgroundColor: colors.bright_turquoise,
    height: 4,
  },
})(MaterialTabs);

const CustomTab = withStyles({
  root: {
    color: colors.silver,
    textTransform: 'none',
    fontSize: 16,
    fontWeight: 600,
    minWidth: 150,
    marginTop: 8,
  },
})(MaterialTab);

export type TabsProps = {
  /** The tab offset to display */
  currentTab?: number;
  /** An array with the tab names */
  tabs: string[];
  /** Called when the tab changes */
  onTabChange: (tabOffset: number) => void;
  /** If true, the tab will apply side paddings for desktop screens */
  useDesktopPadding?: boolean;
  /** Size used for Padded Content */
  desktopSidePadding?: number;
  // backgroundColor of the Tabs
  backgroundColor?: string;
};

const Tabs = ({
  tabs,
  onTabChange,
  currentTab = 0,
  useDesktopPadding = false,
  desktopSidePadding = dimensions.desktopSidePadding,
  backgroundColor,
}: TabsProps): JSX.Element => {
  const classes = useStyles({ paddingValue: desktopSidePadding });

  function handleTabChange(
    _event: React.ChangeEvent<{}>,
    newValue: number,
  ): void {
    onTabChange(newValue);
  }

  return (
    <CustomTabs
      className={useDesktopPadding ? classes.paddedTabContainer : ''}
      value={currentTab}
      style={{ backgroundColor }}
      onChange={handleTabChange}
    >
      {tabs.map(
        (tab: string, index: number): React.ReactElement =>
          index === currentTab ? (
            <CustomTab key={tab} className={classes.selectedTab} label={tab} />
          ) : (
            <CustomTab key={tab} label={tab} />
          ),
      )}
    </CustomTabs>
  );
};

export default Tabs;
